import useFeatureFlag from './useFeatureFlag';

export function useDisplaySignUpBtn() {
  const [displaySignUpBtn] = useFeatureFlag('display_sign_up_btn');
  return { displaySignUpBtn };
}
